var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.hint}},[_c('input',{staticClass:"input",attrs:{"placeholder":_vm.title,"type":_vm.type,"name":_vm.name},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }